// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__R1-Uh","textArea":"TextArea_textArea__yx7qj"};